import React, { useEffect } from 'react';
import { ChatInterface } from '../../components/chat/ChatInterface.v2';
import { socketService } from '../../services/SocketService';
import { useStore } from '../../stores';

/**
 * 聊天页面 - 主要的对话界面
 * 基于设计文档的主聊天页面实现
 */
const ChatPage: React.FC = () => {
  const { user } = useStore();

  useEffect(() => {
    // 页面离开时断开会话

  }, [user?.id]);

  return (
    <div className="min-h-full lg:h-full flex flex-col">
      {/* 聊天界面 */}
      <ChatInterface />
    </div>
  );
};

export default ChatPage;